import { render, staticRenderFns } from "./creacliente.vue?vue&type=template&id=78df03fc&"
import script from "./creacliente.vue?vue&type=script&lang=js&"
export * from "./creacliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports